<template>
  <a-dropdown class="lang-select">
    <span class="action global-lang">
      <a-icon type="global" style="font-size: 16px"/>
      {{langTxt[lang]}}
    </span>
    <a-menu slot="overlay" style="width: 150px;" @click="row => changeLang(row.key)">
      <a-menu-item key="zh_CN">
        <a rel="noopener noreferrer">
          <span role="img" aria-label="简体中文">🇨🇳</span> 简体中文
        </a>
      </a-menu-item>
      <a-menu-item key="en_US">
        <a rel="noopener noreferrer">
          <span role="img" aria-label="English">🇺🇸</span> English
        </a>
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
const langTxt = {
  zh_CN: '简体中文',
  en_US: 'English'
}
export default {
  name: 'LangSelect',
  data () {
    return {
      langTxt
    }
  },
  computed: {
    ...mapState(['lang'])
    
  },
  methods: {
    ...mapMutations(['changeLang'])
  }
}
</script>

<style scoped>
.lang-select{
  display: inline-block;
  height: 100%;
  padding: 0 12px;
  cursor: pointer;
  transition: all .3s;
  color: rgba(0,0,0,.65);
}
</style>
